const mustache = require('mustache');
const itMessages = require('../locales/it');
const enMessages = require('../locales/en');

let locale = 'en';

const messages = {
  it: itMessages,
  en: enMessages,
};

module.exports = {
  setLocale: function(l) {
    locale = l;
  },
  t: function(key, view) {
    return mustache.render(messages[locale][key], view);
  }
};



// WEBPACK FOOTER //
// ./src/utils/i18n.js